import { render, staticRenderFns } from "./AddTargetsToUser.vue?vue&type=template&id=050559e8&"
import script from "./AddTargetsToUser.vue?vue&type=script&lang=js&"
export * from "./AddTargetsToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports